import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ContactsSupport } from '../../components/ContactsSupport';
import { PageHeader } from '../../components/PageHeader';
import { PageContent, PageLayout } from '../../layout';

export const Support = () => {
  const { t } = useTranslation();
  return (
    <PageLayout>
      <PageHeader title={t('support')} backRouteTo={null} />
      <PageContent sx={{ alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'column', pt: '5%' }}>
        <Typography variant={'h3'} mb={2}>
          {t('contact')}
        </Typography>
        <ContactsSupport sx={{ minWidth: '300px' }} />
      </PageContent>
    </PageLayout>
  );
};
